<template>
     <van-overlay :show="showmodal">
      <div class="helpShareView">
        <div class="helpShare">
          <img class="helpShareBtn" src="../../static/images/help_share_btn.png" alt="">
          <p class="helpShareBtnText">点击可进行分享</p>
          <div @click="controlOverlay(false)" class="helpClose">
            <p class="helpCloseText">关闭</p>
          </div>
        </div>
      </div>
    </van-overlay>
</template>
<script>
import Vue from "vue";
import { Overlay } from "vant";
Vue.use(Overlay)
export default {
    name:"OverlayModal",
    props:["showmodal"],
    methods:{
     controlOverlay(status) {
      this.$emit("controlOverlay",status)
    } 
    }
}
</script>
</script>
<style scoped lang="scss" src="../../static/scss/helpme.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>
